import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { graphql, compose, withApollo } from 'react-apollo'
import {
  GET_AGENT_SIZE,
  GET_AGENT_STATE,
  SET_AGENT_STATE,
  GET_AGENT_POSITION,
  SET_AGENT_POSITION,
  GET_ALERT,
  CLEAR_ALERT,
  GET_DICTATION,
  GET_WORKER_STREAM_INFO,
  SET_AUDIO_STREAM_UI_CONTEXT,
  GET_DEBUG,
  GET_CURRENT_COMPOSITION,
  CLEAR_KEYBOARD_MODE,
  GET_KEYBOARD_MODE,
  SET_KEYBOARD_MODE,
  CLEAR_SECTION
} from '../../apollo/actions'
import { LO_STO, SESH_STO, ROUTES, HALF_STORY, WINDOW_EVENTS, setAgentState } from '../../lib'
import loSto from '../../config/loSto'
import seshSto from '../../config/seshSto'
import { startRefreshTimer } from '../../config/okta'
import { Agent, Constants } from '@sukiai/components'
import { SIZES } from './constants'
import { startRecording, stopRecording } from './Recorder'
import { sendSpeechConfig, getStreamWorker } from '../../ws/stream'
import { DataCommand } from '../../ws/DataCommand'
import { getIntercomID } from '../../config'
import { halfStory as hs, logger } from '../../lib/logging'
import { inNoteView, stopSectionDictation, play, isAmwellTheme, isEmbedScriptsView, isAmwellVisitScreen } from '../../lib/util'
import client from '../../apollo'
import { setToggleAgentTask } from '../../helpers/gettingStarted.helpers'
import { AMWELL_AGENT_SIZE, AMWELL_AGENT_MUTE_SIZE } from '../../constants/amwell'
import isNil from 'lodash/isNil'

const { AGENT, SOUNDS } = Constants

// Used only in non-dictation mode
const RESTART_FREQUENCY_IN_MIN = 15
let agentRestartTimerId = null
class AgentContainer extends Component {
  state = {
    doNotActivateAgentDuringWrapup: true
  }

  componentWillMount () {
    const { agentPosition, agentState, agentSize, history, dictation } =
      this.props

    this.convertPosition(agentPosition, SIZES[agentSize])
    getStreamWorker()

    // Refresh token logic
    startRefreshTimer()

    // Toggle mute will set the AGENT to READY state, if the user refreshes the screen and the AGENT was previously recording
    // [TODO: also make sure, this agent is the active agent among all open ones, if not set loSto AGENT_RECORDING state to false]
    // [TODO: LocalStorage is shared across same-origin instances of the app - this messes things up
    //   for multiple agents]
    console.log('bloop agentRecording', seshSto.session(SESH_STO.AGENT_RECORDING))
    seshSto.session(SESH_STO.AGENT_RECORDING) && this.toggleMute()

    // Start timer if not in dictation mode
    if (!dictation && seshSto.session(SESH_STO.AGENT_RECORDING)) {
      this.startRestartTimer()
    } else if (
      agentState === AGENT.STATE.READY &&
      !seshSto.session(SESH_STO.AGENT_RECORDING)
    ) {
      logger.info('[S2 ALERT - FIRST TIME LOGIN - STARTED RECORDING ON LOGIN]')
      startRecording()
      seshSto.session(SESH_STO.KEYBOARD_MODE, false)
    }

    // Listen for route changes
    history.listen((location, action) => {
      hs.add(
        HALF_STORY.NAVIGATION,
        `Navigated to ${location.pathname} via ${action}`
      )
    })
  }

  componentDidUpdate () {
    const isAmwellFirstTimeUser = loSto.get(LO_STO.IS_AMWELL_FIRST_TIME_USER)
    if (isAmwellFirstTimeUser && this.state.doNotActivateAgentDuringWrapup && this.props.agentState !== 'MUTED') {
      setAgentState(AGENT.STATE.MUTED)
      this.setState({ doNotActivateAgentDuringWrapup: false })
    }
  }

  componentWillReceiveProps (nextProps) {
    const { agentState, clearSection } = this.props
    const {
      agentPosition: nextAgentPosition,
      agentSize: nextAgentSize,
      agentState: nextAgentState,
      location: { pathname: nextPathname },
      dictation: nextDictation,
      keyboardMode: nextKeyboardMode
    } = nextProps

    const currentPath = loSto.get(LO_STO.CURRENT_PATH)

    // Dictation mode
    if (nextDictation) {
      agentRestartTimerId && window.clearTimeout(agentRestartTimerId)
      agentRestartTimerId = null
    } else {
      // exited dictation mode or not in dictation mode
      // check if user has no restart timer id
      if (!agentRestartTimerId && nextAgentState !== AGENT.STATE.MUTED) {
        this.startRestartTimer()
      }
      // else, continue letting the timer tick.
    }

    this.convertPosition(nextAgentPosition, SIZES[nextAgentSize])

    // KEYBOARD MODE CHECKS
    if (
      nextPathname.includes(ROUTES.NOTE) &&
      nextKeyboardMode === false &&
      nextAgentState === AGENT.STATE.MUTED
    ) {
      client.mutate({ mutation: SET_KEYBOARD_MODE })
      seshSto.session(SESH_STO.KEYBOARD_MODE, true)
      logger.info(
        '[S2 ALERT - SETTING KEYBOARD_MODE FROM CLIENT - SINCE AGENT IS OFF & WE ARE IN NOTE VIEW]'
      )
    }

    // UI View Context for streaming-gateway
    if (currentPath !== nextPathname) {
      // Refresh intercom
      window.Intercom('update', { app_id: getIntercomID() })

      // Let note container send its own content
      if (!nextPathname.includes(ROUTES.NOTE)) {
        sendSpeechConfig('Restart stream since route changed.')
      }

      loSto.set(LO_STO.CURRENT_PATH, nextPathname)
    }

    // TODO: FLIP AROUND THE BADGE STATE based on RECORDING
    // We only touch the recorder if the agent state changes
    // and we only care about two cases to start or stop it
    // 1. START: If the agent was MUTED and is now any other state
    // 2. STOP: If the agent wasn't MUTED before, but is getting MUTED now
    // If we are going from READY to AWAKE, we don't touch the recorder
    // since it should already be on when it went from MUTED to READY
    if (
      nextAgentState !== agentState &&
      (nextAgentState === AGENT.STATE.MUTED || agentState === AGENT.STATE.MUTED)
    ) {
      console.log('bloop componentWillReceiveProps', nextAgentState)
      if (nextAgentState === AGENT.STATE.MUTED) {
        // KEYBOARD MODE CHECKS
        if (nextKeyboardMode === false) {
          client.mutate({ mutation: SET_KEYBOARD_MODE })
          seshSto.session(SESH_STO.KEYBOARD_MODE, true)
          logger.info(
            '[S2 ALERT - SETTING KEYBOARD_MODE FROM CLIENT - SINCE AGENT IS TURNING OFF]'
          )
        }

        stopRecording()
      } else {
        // KEYBOARD MODE CHECKS
        if (nextKeyboardMode === true) {
          client.mutate({ mutation: CLEAR_KEYBOARD_MODE })
          seshSto.session(SESH_STO.KEYBOARD_MODE, false)
          logger.info(
            '[S2 ALERT - CLEARING KEYBOARD_MODE FROM CLIENT - SINCE AGENT IS TURNING ON]'
          )
          logger.info('[S2 ALERT - CLIENT EXITING KEYBOARD MODE]')

          // clears current section if not in dictation mode
          !nextDictation && clearSection()

          hs.add(HALF_STORY.KEYBOARD_MODE_OFF, 'Setting KEYBOARD_MODE to OFF')
          const stream = getStreamWorker()
          stream &&
            stream.postMessage({
              cmd: DataCommand.EVENT,
              eventType: 'KEYBOARD_OFF',
              ts: new Date().toISOString()
            })
          logger.info(
            '[S2 ALERT - KEYBOARD_OFF FOLLOWED BY AUDIO_START SENT BY CLIENT]'
          )
          // AUDIO_START will be automatically sent with speech_start to the S2 server from Agent's
          // startRecording function
        }
        startRecording()
      }
    }
  }

  componentDidMount () {
    // event listeners to control local storage if agent was activated in other tab & to control if tab closed
    if (window) {
      window.addEventListener(WINDOW_EVENTS.STORAGE, this.handleAgentStateOnActiveTabChanged)
      window.addEventListener(WINDOW_EVENTS.BEFORE_UNLOAD, this.clearActiveTabInLocalStorage)
    }

    const { agentState, setAgentState, match } = this.props
    if (isNil(loSto.get(LO_STO.ACTIVE_TAB)) && !isNil(seshSto.session(SESH_STO.TAB_ID)) && !isEmbedScriptsView(match.url) && !isAmwellVisitScreen()) {
      if (agentState === AGENT.STATE.MUTED) {
        setAgentState(AGENT.STATE.READY)
        // also clear restart timeout if any
        agentRestartTimerId && window.clearTimeout(agentRestartTimerId)
        agentRestartTimerId = null
      }
      seshSto.session(SESH_STO.KEYBOARD_MODE, false)
    }

    if ((!isNil(loSto.get(LO_STO.ACTIVE_TAB)) && (seshSto.session(SESH_STO.TAB_ID) !== loSto.get(LO_STO.ACTIVE_TAB))) || (isEmbedScriptsView(match.url))) {
      stopRecording()
    }
  }

  handleAgentStateOnActiveTabChanged = () => {
    if (!isNil(loSto.get(LO_STO.ACTIVE_TAB)) && seshSto.session(SESH_STO.TAB_ID) !== loSto.get(LO_STO.ACTIVE_TAB)) {
      this.muteAgent()
    }
  }

  clearActiveTabInLocalStorage = () => {
    (seshSto.session(SESH_STO.TAB_ID) === loSto.get(LO_STO.ACTIVE_TAB)) &&
    loSto.remove(LO_STO.ACTIVE_TAB)
  }

  startRestartTimer = () => {
    if (!agentRestartTimerId) {
      console.info(
        `Setting timer to restart agent in ${RESTART_FREQUENCY_IN_MIN} minute(s).`
      )
      logger.info(
        `Setting timer to restart agent in ${RESTART_FREQUENCY_IN_MIN} minute(s).`
      )
      agentRestartTimerId = window.setInterval(
        this.toggleAgentOffOn,
        RESTART_FREQUENCY_IN_MIN * 60 * 1000
      )
    }
  };

  convertPosition = (positionConstant, agentSize) => {
    const {
      vw,
      vh,
      isSmallNoteWindow,
      isCrampedListPanelWindow,
      isSmallListPanelWindow
    } = this.props

    let x = null
    let y = null

    if (isSmallNoteWindow || isSmallListPanelWindow) {
      // TODO: these need to be set more accurately
      x = vw / 2 - (agentSize * vw) / 2
      y = vh - agentSize * vw
      this.setState({ positionCoordinates: { x: x, y: y } })
      return
    }

    switch (positionConstant) {
      case AGENT.POSITION.TOP_LEFT:
        if (isCrampedListPanelWindow) {
          x = (vw * 0.12) / 2 - (agentSize * vw) / 2
        } else {
          x = (vw * 0.24) / 2 - (agentSize * vw) / 2
        }
        y = 220 - (agentSize * vw) / 2 - agentSize * vw * 0.125
        break
      case AGENT.POSITION.MIDDLE_LEFT:
        if (isCrampedListPanelWindow) {
          x = vw / 6 - (agentSize * vw) / 2
        } else {
          x = vw / 4 - (agentSize * vw) / 2
        }
        y = vh / 2 - (agentSize * vw) / 2
        break
      case AGENT.POSITION.LEFT:
        if (isCrampedListPanelWindow) {
          x = vw * 0.075 - (agentSize * vw) / 2
        } else {
          x = vw * 0.15 - (agentSize * vw) / 2
        }
        y = vh / 2 - (agentSize * vw) / 2
        break
      case AGENT.POSITION.LEFT_MIDDLE:
        if (isCrampedListPanelWindow) {
          x = vw * 0.085 - (agentSize * vw) / 2
        } else {
          x = vw * 0.17 - (agentSize * vw) / 2
        }
        y = vh / 2 - (agentSize * vw) / 2
        break
      case AGENT.POSITION.CENTER:
      default:
        x = vw / 2 - (agentSize * vw) / 2
        y = vh / 2 - (agentSize * vw) / 2
        break
    }

    if (x && y) {
      this.setState({ positionCoordinates: { x: x, y: y } })
    }
  };

  // Could happen in the following cases:
  // 1. User clicks the badge to unmute it
  // 2. User refreshes the screen and the previous agent state was `Recording`
  // 3. User logs out
  toggleMute = () => {
    const { agentState, dictation, setAgentState, pingTimeout } = this.props

    // If there's a ping timeout, don't
    // allow the agent to be unmuted
    if (pingTimeout) {
      this.muteAgent()
      return
    }

    // if user in noteview + isdictating
    // remove sectionIndicators

    if (inNoteView() && dictation) {
      this.stopNoteAgent()
      return
    }

    const currentTabId = seshSto.session(SESH_STO.TAB_ID)
    const activeTabId = loSto.get(LO_STO.ACTIVE_TAB)

    if (agentState !== AGENT.STATE.MUTED) {
      this.muteAgent()

      // if we muted agent in tab - this tab is no active one no more
      if (currentTabId === activeTabId) {
        loSto.remove(LO_STO.ACTIVE_TAB)
      }
    } else if (dictation) {
      setAgentState(AGENT.STATE.LISTENING)
    } else {
      const isSocketAuthenticated = seshSto.session(
        SESH_STO.SOCKET_AUTHENTICATED
      )
      console.log('bloop setting AGENT.STATE.READY')
      if (isSocketAuthenticated) {
        // set tab as active on agent unmute
        if (currentTabId !== activeTabId) {
          loSto.set(LO_STO.ACTIVE_TAB, currentTabId)
        }

        setAgentState(AGENT.STATE.READY)
        setToggleAgentTask()
      }

      // not in dictation mode
      this.startRestartTimer()
    }
  };

  stopNoteAgent = () => {
    const { agentState, setAudioStreamContext, client } = this.props

    const { composition } = client.readQuery({
      query: GET_CURRENT_COMPOSITION
    })

    const compositionData = JSON.parse(composition)

    hs.add(
      HALF_STORY.EXIT_DICTATION_BADGE_PRESSED,
      'Sending EXIT_DICTATION_BADGE_PRESSED since agent was turned off'
    )
    const stream = getStreamWorker()
    stream &&
      stream.postMessage({
        cmd: DataCommand.USER_REQUEST,
        userRequestType: 'EXIT_DICTATION_BADGE_PRESSED',
        userRequestData: {
          compositionId: compositionData?.id,
          notetypeId: compositionData?.metadata?.noteTypeId
        },
        ts: new Date().toISOString()
      })

    setAudioStreamContext({
      agentAwake: false,
      transcription: false,
      isScriptChange: false,
      sectionId: '',
      patientId: ''
    }).then(() => {
      hs.add(HALF_STORY.VOICE, 'Stopping Dictation.')
      sendSpeechConfig('Sending new speech configuration on STOP_DICTATION.')
      // Also save to half story
      hs.save()
    })

    play(SOUNDS.EXIT_DICTATION)

    // agent state, should clear section & section id is unknown here
    stopSectionDictation(agentState, true, null)
  };

  muteAgent = () => {
    const { agentState, setAgentState } = this.props

    if (agentState !== AGENT.STATE.MUTED) {
      setAgentState(AGENT.STATE.MUTED)
      // also clear restart timeout if any
      agentRestartTimerId && window.clearTimeout(agentRestartTimerId)
      agentRestartTimerId = null
    }
  };

  // Only called if the agent has been in non-dictation mode for >10 minutes
  toggleAgentOffOn = () => {
    const { setAgentState } = this.props

    setAgentState(AGENT.STATE.MUTED)
    // turn agent back on after 800 ms
    setTimeout(() => {
      console.info(
        `Toggling agent OFF and ON again, since we hit the ${RESTART_FREQUENCY_IN_MIN} minute timeout for this session.`
      )
      setAgentState(AGENT.STATE.READY)
      this.startRestartTimer()
    }, 800)
    logger.info(
      `Toggling agent OFF and ON again, since we hit the ${RESTART_FREQUENCY_IN_MIN} minute timeout for this session.`
    )
  };

  render () {
    const { agentSize, agentState, alert, clearAlert, vw, match } = this.props

    const _agentSize = () => {
      if (isAmwellTheme()) {
        return agentState === AGENT.STATE.MUTED ? AMWELL_AGENT_MUTE_SIZE : AMWELL_AGENT_SIZE
      } else if (window.innerWidth <= 600) {
        return 130
      }
      return SIZES[agentSize] * vw
    }

    if (isEmbedScriptsView(match?.url)) {
      return null
    }

    return (
      <Agent
        toggleMute={this.toggleMute}
        size={_agentSize()}
        agentState={agentState}
        positionCoordinates={this.state.positionCoordinates}
        alert={alert}
        clearAlert={clearAlert}
        muteAgent={this.muteAgent}
      />
    )
  }
}

export default compose(
  withRouter,
  graphql(GET_AGENT_SIZE, {
    props: ({ data: { agentSize } }) => ({
      agentSize
    })
  }),
  graphql(GET_AGENT_STATE, {
    props: ({ data: { agentState } }) => ({
      agentState
    })
  }),
  graphql(SET_AGENT_STATE, {
    props: ({ mutate }) => ({
      setAgentState: (agentState) =>
        mutate({
          variables: { agentState }
        })
    })
  }),
  graphql(GET_AGENT_POSITION, {
    props: ({ data: { agentPosition } }) => ({
      agentPosition
    })
  }),
  graphql(SET_AGENT_POSITION, {
    props: ({ mutate }) => ({
      setAgentPosition: (agentPosition) =>
        mutate({
          variables: { agentPosition }
        })
    })
  }),
  graphql(GET_ALERT, {
    props: ({ data: { alert } }) => ({
      alert
    })
  }),
  graphql(CLEAR_ALERT, { name: 'clearAlert' }),
  graphql(CLEAR_SECTION, { name: 'clearSection' }),
  graphql(GET_DICTATION, {
    props: ({ data: { dictation } }) => ({
      dictation
    })
  }),
  graphql(GET_WORKER_STREAM_INFO, {
    props: ({ data: { streamInfo } }) => ({
      streamId: streamInfo.streamId
    })
  }),
  graphql(SET_AUDIO_STREAM_UI_CONTEXT, {
    props: ({ mutate }) => ({
      setAudioStreamContext: (context) =>
        mutate({
          variables: { audioStreamUIContext: context }
        })
    })
  }),
  graphql(GET_KEYBOARD_MODE, {
    props: ({ data: { keyboardMode } }) => {
      return { keyboardMode }
    }
  }),
  graphql(GET_DEBUG, {
    props: ({
      data: {
        debug: { pingTimeout }
      }
    }) => ({
      pingTimeout
    })
  }),
  withApollo
)(AgentContainer)
